import { render, staticRenderFns } from "./EmployeeIndividualAwayAssignmentModal.vue?vue&type=template&id=27b86b30&scoped=true&"
import script from "./EmployeeIndividualAwayAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeIndividualAwayAssignmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b86b30",
  null
  
)

export default component.exports